var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"0px"}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{attrs:{"align-h":"start"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('h2',[_vm._v("Settings")]),_c('hr')])],1),_c('b',[_vm._v("KAMINO-Backend Server")]),_c('br'),_vm._v(_vm._s(this.$http.options.root)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }